import { createFileRoute } from '@tanstack/react-router'
import { serviceVisitQueryOptions } from '../../../../../features/service/queries'
import { VisitReportPrintPage } from '../../../../../features/service/visit-report-print-page'

export const Route = createFileRoute('/_app/service/visits/$visitId/report')({
  staticData: { crumb: 'serviceVisitReport' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(serviceVisitQueryOptions(params.visitId)),
  component: VisitReportPrintPage,
})
